export class LocationIdModel {
    id: number = 0;
}